import { gql } from "@apollo/client";

export default gql`
  query managerByEmployerId(
    $employerId: ID
    $isAll: Boolean
  ) {
    managerByEmployerId(
      employerId: $employerId
      isAll: $isAll
    ) {
        id
        title
        isActive
        employerId
        manager{
          id
          email
          firstName
          lastName
          countryCode
          mobilePhone
          signedProfileImageUrl
        }
    }
  }
`;
